module.exports = "<div id=\"{{$ctrl.id}}\" ng-class=\"['subnav-wrapper', {primary: $ctrl.primary}]\" ng-transclude>\n</div><!-- /.subnav-wrapper -->\n<div class=\"indicator no-transition\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpSubnavigation/adpSubnavigation.html
// module id = 459
// module chunks = 0